import { Injectable, EventEmitter } from "@angular/core";
import {NavItem} from './Interfaces/NavItem';
import {User} from './Interfaces/User';
import {Subscription} from 'rxjs';

@Injectable()
export class GlobalEventsManager {
  /* Darren: important, we are passing in "true" to the showSpinner eventEmitter. There is an error being thrown :
  ExpressionChangedAfterItHasBeenCheckedError: when the menus are being brought up. This will stop that.
   */
  public showNavBar: EventEmitter<any> = new EventEmitter();
  public showLogin: EventEmitter<boolean> = new EventEmitter();
  public theirName: EventEmitter<any> = new EventEmitter();
  public userObj: EventEmitter<User> = new EventEmitter();
  public menuFound: EventEmitter<boolean> = new EventEmitter();
  public role: EventEmitter<any> = new EventEmitter();
  public navItems : EventEmitter<NavItem[]> = new EventEmitter();
  public myAccount : EventEmitter<NavItem> = new EventEmitter();
  public myHelp : EventEmitter<NavItem> = new EventEmitter();
  public TOrequests : EventEmitter<any> = new EventEmitter();
  public reportItems : EventEmitter<any> = new EventEmitter();
  public messageArray : EventEmitter<any> = new EventEmitter();
  public cusSubscription : EventEmitter<Subscription> = new EventEmitter();
  public AmSubscription : EventEmitter<any> = new EventEmitter();
  public showSpinner :  EventEmitter<any> = new EventEmitter(true);
  public underMaint :  EventEmitter<boolean> = new EventEmitter(true);

}
